import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import styled, { css } from 'styled-components';

const commonStyles = css`
  color: ${(props) =>
    props.secondaryBtn ? `white` : `rgba(250, 250, 250)`} !important;
  background-color: ${(props) => props.$bgColor} !important;
  border: ${(props) =>
    props.secondaryBtn ? `1px solid white` : 'none'} !important;
  &:hover {
    background-color: ${(props) => props.$bgColorHover} !important;
    color: ${(props) => props.secondaryBtn && `rgba(250, 250, 250)`} !important;
  }
`;

const StyledButtonInternal = styled((props) => <Link {...props} />)`
  ${commonStyles}
`;

const StyledButtonExternal = styled.a`
  ${commonStyles}
`;

const StyledButtonForm = styled.button`
  ${commonStyles}
`;

const StyledAnchorLink = styled((props) => <AnchorLink {...props} />)`
  ${commonStyles}
  &:hover {
    color: ${(props) => props.$colorHover};
  }
`;

const Button = (props) => {
  const {
    sanity,
    linkType,
    label,
    internalLink,
    externalLink,
    jumpLink,
    secondaryBtn,
  } = props;
  const { colors } = sanity;
  const commonProps = {
    className:
      'inline-flex text-center mx-auto lg:mx-0 w-full lg:w-fit items-center py-3 px-6 text-lg font-bold text-zinc-50 hover:text-white  rounded-full shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zinc-500 hover:-translate-y-0.5 translate transform transition-all',
    $bgColor: secondaryBtn ? 'transparent' : colors?.accent?.default,
    $bgColorHover: secondaryBtn
      ? colors?.accent?.default
      : colors?.accent?.dark,
    $borderColor: colors?.accent?.default, // Pass borderColor to styled component
    secondaryBtn, // pass secondaryBtn prop
  };

  const link =
    internalLink === 'home' ||
    internalLink === '/home' ||
    internalLink === '/home/' ||
    internalLink === '/'
      ? '/'
      : `/${internalLink}/`;

  switch (linkType) {
    case 'internal':
      return (
        <StyledButtonInternal to={link} {...commonProps}>
          <span className="mx-auto">{label}</span>
        </StyledButtonInternal>
      );
    case 'external':
      return (
        <StyledButtonExternal
          href={externalLink}
          target="_blank"
          rel="noopener"
          {...commonProps}
        >
          <span className="mx-auto">{label}</span>
        </StyledButtonExternal>
      );
    case 'form':
      return (
        <StyledButtonForm type="submit" value="Submit" {...commonProps}>
          <span className="mx-auto">{label}</span>
        </StyledButtonForm>
      );
    case 'anchor':
      return (
        <StyledAnchorLink
          to={jumpLink}
          secondaryBtn={secondaryBtn}
          $colorHover={
            secondaryBtn ? colors?.accent?.default : colors?.accent?.dark
          }
          {...commonProps}
        >
          <span className="mx-auto">{label}</span>
        </StyledAnchorLink>
      );
    default:
      return (
        <StyledButtonInternal to={link} {...commonProps}>
          <span className="mx-auto">{label}</span>
        </StyledButtonInternal>
      );
  }
};

Button.defaultProps = {
  linkType: 'internal',
  label: 'Call Now',
  internalLink: '/',
  externalLink: '#',
  jumpLink: '#',
  secondaryBtn: false,
};

Button.propTypes = {
  linkType: PropTypes.oneOf(['internal', 'external', 'form', 'anchor']),
  label: PropTypes.string,
  internalLink: PropTypes.string,
  externalLink: PropTypes.string,
  jumpLink: PropTypes.string,
  secondaryBtn: PropTypes.bool,
  colors: PropTypes.object,
};

export { Button };
